(function () {
  'use strict';

  /* ---------- Money ---------- */
  function formatMoney(cents) {
    var fmt = (window.Snugo && window.Snugo.moneyFormat) || '£{{amount}}';
    function withDelims(n, dec, thou, sep) {
      var parts = (n / 100).toFixed(dec).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thou);
      return parts.join(sep);
    }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, key) {
      switch (key) {
        case 'amount_no_decimals': return withDelims(cents, 0, ',', '.');
        case 'amount_with_comma_separator': return withDelims(cents, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return withDelims(cents, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return withDelims(cents, 2, "'", '.');
        default: return withDelims(cents, 2, ',', '.');
      }
    });
  }
  function shortMoney(cents) {
    var s = formatMoney(cents);
    return cents % 100 === 0 ? s.replace(/[.,]00(?=\D*$)/, '') : s;
  }

  /* ---------- Marquees: repeat content so the loop is seamless ---------- */
  function initMarquees(root) {
    (root || document).querySelectorAll('[data-marquee]').forEach(function (t) {
      if (t.dataset.ready) return;
      t.dataset.ready = '1';
      var html = t.innerHTML;
      t.innerHTML = html + html + html + html;
    });
  }

  /* ---------- Header ---------- */
  function initHeader(root) {
    var scope = root || document;
    scope.querySelectorAll('[data-menu-toggle]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var nav = document.getElementById(btn.getAttribute('aria-controls'));
        if (!nav) return;
        nav.hidden = !nav.hidden;
        btn.setAttribute('aria-expanded', String(!nav.hidden));
      });
    });
    scope.querySelectorAll('[data-search-toggle]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var bar = document.getElementById(btn.getAttribute('aria-controls'));
        if (!bar) return;
        bar.hidden = !bar.hidden;
        btn.setAttribute('aria-expanded', String(!bar.hidden));
        if (!bar.hidden) { var i = bar.querySelector('input'); if (i) i.focus(); }
      });
    });
    scope.querySelectorAll('[data-autosubmit]').forEach(function (sel) {
      sel.addEventListener('change', function () { sel.form.submit(); });
    });
  }

  /* ---------- Quantity steppers (product + cart) ---------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-qty]');
    if (!b) return;
    var input = b.parentElement.querySelector('input[type="number"]');
    if (!input) return;
    var min = parseInt(input.min || '0', 10);
    var max = parseInt(input.max || '999', 10);
    var v = (parseInt(input.value, 10) || 0) + parseInt(b.dataset.qty, 10);
    input.value = Math.max(min, Math.min(max, v));
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });
  // Cart: submit the update when a quantity changes
  var cartTimer;
  document.addEventListener('change', function (e) {
    if (!e.target.matches('[data-autoupdate]')) return;
    clearTimeout(cartTimer);
    var form = e.target.form;
    cartTimer = setTimeout(function () {
      var hidden = document.createElement('input');
      hidden.type = 'hidden'; hidden.name = 'update'; hidden.value = '1';
      form.appendChild(hidden);
      form.submit();
    }, 500);
  });

  /* ---------- Product variant picker ---------- */
  function initProducts(root) {
    (root || document).querySelectorAll('[data-product]').forEach(function (wrap) {
      if (wrap.dataset.ready) return;
      wrap.dataset.ready = '1';
      var json = wrap.querySelector('[data-variants]');
      var variants = [];
      try { variants = JSON.parse(json.textContent); } catch (err) { return; }
      var idInput = wrap.querySelector('[data-variant-id]');
      var priceEl = wrap.querySelector('[data-price]');
      var compareEl = wrap.querySelector('[data-compare]');
      var addBtn = wrap.querySelector('[data-add]');
      var addLabel = wrap.querySelector('[data-add-label]');
      var colourName = wrap.querySelector('[data-colour-name]');
      var art = wrap.querySelector('[data-product-art]');

      function selected() {
        var out = [];
        for (var i = 1; i <= 3; i++) {
          var c = wrap.querySelector('input[data-option="' + i + '"]:checked');
          if (c) out.push(c.value);
        }
        return out;
      }
      function setImage(src) {
        if (!src || !art) return;
        var img = art.querySelector('.product-photo');
        if (!img) {
          img = document.createElement('img');
          img.className = 'product-photo';
          img.alt = '';
          var svg = art.querySelector('.hoodie-art');
          if (svg) svg.remove();
          art.insertBefore(img, art.firstChild);
        }
        img.removeAttribute('srcset');
        img.src = src;
      }
      function update() {
        var opts = selected();
        var v = variants.find(function (x) {
          return x.options.every(function (o, i) { return o === opts[i]; });
        });
        opts.forEach(function (val, i) {
          var lab = wrap.querySelector('[data-option-label="' + (i + 1) + '"]');
          if (lab) lab.textContent = val;
        });
        if (colourName) {
          var checkedSwatch = wrap.querySelector('.swatches input:checked');
          if (checkedSwatch) colourName.textContent = checkedSwatch.value;
        }
        if (!v) {
          addBtn.disabled = true;
          addLabel.textContent = 'Unavailable';
          return;
        }
        idInput.value = v.id;
        priceEl.textContent = formatMoney(v.price);
        if (compareEl) {
          compareEl.hidden = !(v.compare > v.price);
          compareEl.textContent = formatMoney(v.compare);
        }
        addBtn.disabled = !v.available;
        addLabel.textContent = v.available ? 'Add to cart · ' + shortMoney(v.price) : 'Sold out';
        if (v.image) setImage(v.image);
        if (wrap.closest('.template-product') && window.history.replaceState) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', v.id);
          window.history.replaceState({}, '', url.toString());
        }
      }
      wrap.querySelectorAll('input[data-option]').forEach(function (r) {
        r.addEventListener('change', update);
      });
      wrap.querySelectorAll('[data-thumb]').forEach(function (b) {
        b.addEventListener('click', function () { setImage(b.dataset.thumb); });
      });
    });
  }

  function initAll(root) { initMarquees(root); initHeader(root); initProducts(root); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
  else initAll();

  // Re-run when sections are edited in the theme editor
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
